import React, {useState} from 'react';
import {Alert, Button, Col, Row,} from 'react-bootstrap';
import {PlusLg} from 'react-bootstrap-icons';
import ModalSelection from '../../UI/modals/ModalSelection';

export default function AddSelection({
  title, options, selectedValues, onChange, readOnly, singleChoice, required, addButtonLabel = 'Добавить', buttonCol, isNotDefault, disabled
}) {
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setFilteredResults(options);
    setSearchInput('');
  };
  const handleShow = () => setShow(true);

  const handleCheck = (key) => {
    if (!disabled){
      if (!singleChoice) {
        if (isChecked({ key })) {
          onChange((selectedValues || []).filter((v) => v !== key));
        } else {
          onChange(selectedValues.concat([key]));
        }
      } else if (!required && isChecked({ key })) {
        onChange(null);
      } else {
        onChange(key);
      }
    }
  };

  const isChecked = (item) => selectedValues && selectedValues.includes(item.key);

  const [filteredResults, setFilteredResults] = useState([]);
  const [searchInput, setSearchInput] = useState('');

  const searchItems = (searchValue) => {
    const extractTextFromHtml = (item) => item.map((x) => !x?.props ? x : extractTextFromHtml(x.props.children)).join('');

    setSearchInput(searchValue);
    if (searchInput !== '') {
      const filteredData = options.filter((item) => {
        const currentString = item.text?.props && extractTextFromHtml(item.text.props.children)
        return !!currentString
            ? currentString.toLowerCase().includes(searchInput.toLowerCase())
            : Object.values(item).join('').toLowerCase().includes(searchInput.toLowerCase());
      });
      setFilteredResults(filteredData);
    } else {
      setFilteredResults(options);
    }
  };

  const clearValue = () => {
    setFilteredResults(options);
    setSearchInput('');
  };

  return (
    <>
      <div>
        {options.map((item, index) => (
          isChecked(item)
            && !isNotDefault && (
            <Alert
              key={item.key}
              variant="primary"
              onClose={() => handleCheck(item.key)}
              dismissible={!readOnly && (!required || options.filter((e) => isChecked(e)).length > 1)}
            >
              {item.text}
            </Alert>
          )
        ))}
      </div>
      {!readOnly && (
      <Row>
        <Col className="col-auto">
          <Button onClick={handleShow} disabled={disabled} variant="outline-primary">
            <PlusLg className="me-1 mb-1" />
            {addButtonLabel}
          </Button>
        </Col>
        <Col>
          {buttonCol}
        </Col>
      </Row>
      )}

      <ModalSelection
        required={required}
        filteredResults={filteredResults}
        handleCheck={handleCheck}
        isChecked={isChecked}
        handleClose={handleClose}
        options={options}
        clearValue={clearValue}
        show={show}
        searchInput={searchInput}
        searchItems={searchItems}
        title={title}
      />
    </>
  );
}
